<app-option-bar [type]="moduleType" [details]="moduleDetails"></app-option-bar>
<div class="endpoint-wrapper notification-section">
  <div class="container-fluid">
    <div class="content-wrapper">
      <!-- Menu Section -->
      <div class="inner-nav">
        <app-left-menu [details]="moduleDetails" [type]="moduleType"></app-left-menu>
      </div>
      <div class="inner-content collapsed">
        <section class="common-section">
          <div style="display: flex;">
            <div class="common-heading">Configuration</div>
            <a style="margin-left: auto;" ngbTooltip="Notification Help" placement="left" (click)="openHelpLink()">
              <small>Help</small>
              <img src="/assets/images/icons/help.gif" width="25px" alt="" />
            </a>
          </div>
          <div class="common-box">
            <div class="execution-sec" *ngFor="let item of notificationConfigData.notificationConfigDto?.notificationTypeConfigDtos" [hidden]="moduleType === 'TESTCASE' ? !(item.notificationType === 'LOAD_TEST' || item.notificationType !== 'WATCHER') : !(item.notificationType !== 'LOAD_TEST' && item.notificationType !== 'WATCHER')">
              <div class="row">
                <div class="col-md-8">
                  <div class="row">
                    <div class="heading col-md-12 col-sm-6 col-xs-6">{{item.notificationType}}</div>
                    <div class="col-md-2 col-sm-6 col-xs-6" style="line-height: 3em;">Active
                      <input type="checkbox" [(ngModel)]="item.active" (ngModelChange)="pageHasUpdate = true;"/>
                    </div>
                    <div class="col-md-2 col-sm-6 col-xs-6" style="line-height: 3em;">Failure
                      <input type="checkbox" [(ngModel)]="item.failureOnly" (ngModelChange)="pageHasUpdate = true;"/>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-6" style="line-height: 3em;" *ngIf="(moduleType === 'TESTCASE' || moduleType === 'TESTSUITE') && item.notificationType !== 'LOAD_TEST'" >
                      <div *ngIf="item.notificationType !== 'LOAD_TEST'">
                        Notify By Parent
                      <i class="fas fa-info-circle" placement="top" ngbTooltip="Notify the child execution when parent gets executed"></i>
                      <input type="checkbox" [(ngModel)]="item.notifyByParentExecution" (ngModelChange)="pageHasUpdate = true;"/>
                      </div>
                    </div>
                    <div class="col-md-2 col-sm-6 col-xs-6" style="line-height: 3em;" *ngIf="item.notificationType !== 'LOAD_TEST'">
                      <div>
                        Detailed
                        <input type="checkbox" [(ngModel)]="item.detailedEmail" (ngModelChange)="pageHasUpdate = true;"/><br />
                      </div>
                      <div *ngIf="item.detailedEmail">
                        Failed first <input type="checkbox" [(ngModel)]="item.failedTestFirst" (ngModelChange)="pageHasUpdate = true;" ngbTooltip="Failed test would appear in the top" />
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-6" style="line-height: 3em;" *ngIf="item.detailedEmail">Endpoint Table
                      <input type="checkbox" [(ngModel)]="item.enableEndpointTable" (ngModelChange)="pageHasUpdate = true;"/>
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                      <form class="form-inline" #emailForm="ngForm" (ngSubmit)="addNewEmailId(item)" novalidate>
                        <label>Email address</label>
                        <input style="margin: 0 10px;" type="email" name="emailId" class="form-control form-control-sm" placeholder="Add new email id" [(ngModel)]="item.newEmailId" (ngModelChange)="pageHasUpdate = true;" required #newEmail="ngModel" email="true"/>
                        <button type="submit" style="border: none; background-color: #fff;" [disabled]="newEmail.errors?.email">
                          <img src="/assets/images/icons/save-alt@2x.png" ngbTooltip="Add to email id list" width="20px" />
                        </button>
                        <span class="error-msg" *ngIf="newEmail.errors?.email">Invalid email address !!!</span>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="heading">Email ID(s)</div>
                  <ul class="email-sec list-unstyled" *ngIf="item.emailIds && item.emailIds.length > 0">
                    <li *ngFor="let email of item.emailIds; index as index">
                      {{email}}
                      <img src="/assets/images/icons/revoke-alt.png" class="float-right" width="18px" ngbTooltip="Remove email id" (click)="item.emailIds.splice(index, 1)" />
                    </li>
                  </ul>
                </div>
              </div>

              <div style="box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.55); border-left: 5px solid #ccc; margin-bottom: 5px; margin-top: 5px;">
                <div style="display: flex;">
                  <span style="font-weight: 800; font-size: 15px; margin: 5px 10px;">Customised Email</span><br>
                  <div style="margin-left: auto; padding: 5px; margin-right: 25px;" *ngIf="item.notificationType !== 'LOAD_TEST'">
                    Disable Contact Us Link
                    <input style="margin-top: 5px 5px;" type="checkbox" [(ngModel)]="item.excludeContatUsLink" (ngModelChange)="pageHasUpdate = true;"/>
                  </div>
                </div>
                <div class="row" style="display: flex; margin-left: 6px;">
                  <div style="margin: 5px 5px 10px 15px; width: 48%;">Custom Subject
                    <i class="fas fa-info-circle" styleplacement="top" ngbTooltip="The Custom Subject will be the subject line of email notification, Place holders (Response Extractor) can be part of the Custom subject line."></i>
                    <textarea style="width: 100%; margin: 5px 0px;" name="customSubject" class="form-control form-control-sm" placeholder="Add Custom Subject" [(ngModel)]="item.customSubject" (ngModelChange)="pageHasUpdate = true;" rows="2"></textarea>
                  </div>

                  <div style="margin: 5px 5px 10px 15px; width: 48%;">Custom Body
                    <i class="fas fa-info-circle" styleplacement="top" ngbTooltip="The custom content added here will replace the original content, while the table structure will remain unchanged."></i>
                    <textarea style="width: 100%; margin: 5px 0px;" name="customSubject" class="form-control form-control-sm" placeholder="Add Custom Subject" [(ngModel)]="item.customBody" (ngModelChange)="pageHasUpdate = true;" rows="2"></textarea>
                  </div>

                  <div style="margin: 5px 5px 10px 15px; width: 48%;">Custom Signature
                    <i class="fas fa-info-circle" styleplacement="top" ngbTooltip="The Custom Signature will be the Signature line of email notification, which will override the default Relay signature."></i>
                    <textarea style="width: 100%; margin: 5px 0px;" name="customSignature" class="form-control form-control-sm" rows="2" placeholder="Add Custom Signature" [(ngModel)]="item.customSignature" (ngModelChange)="pageHasUpdate = true;"></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="text-right relay-margin-top-10">
            <button class="btn relay-btn save" (click)="saveEmailId(notificationConfigData)">Save</button>
            <button class="btn relay-btn cancel" (click)="getNotifConfig()">Cancel</button>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
